// extracted by mini-css-extract-plugin
module.exports = {"container":"CarouselSectionSlide_container__gqAZr"};